import React from 'react';
const SvgZdf = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", viewBox: "0 0 72.5 42.7", ...props },
    React.createElement("path", { d: "M48.4 27.5H44V15.4h4.4c3.4 0 4.7 1.5 4.7 6 0 4.6-1.3 6.1-4.7 6.1m16.4-12.1h6.9v-3.3h-8.4c-4.5 0-6.3 2.5-6.3 6.5v.4c-.8-4.6-3.5-6.8-8.6-6.8H40C36.6 5.3 29.5.6 21.4.6 9.9.6.6 9.9.6 21.4s9.3 20.8 20.8 20.8c8.1 0 15.1-4.6 18.6-11.4h8.6c2.1 0 3.9-.1 5.8-1.6 1.4-1.1 2.2-2.6 2.6-4.6v6.2h4v-7.3h9.4v-3.3H61l.1-1.3c-.1-2.2.6-3.5 3.7-3.5", style: {
            opacity: 0.5,
            fill: '#fff',
        } }),
    React.createElement("path", { d: "M30.6 19.8h2.6c2.1 0 3.3-.4 3.3-2.2s-1.2-2.3-3.3-2.3h-8.8V12h10.2c5.2 0 5.9 3.6 5.9 5.6 0 2.1-.9 5.6-5.9 5.6h-2.5c-3.1 0-3.8 1.1-3.8 3.3v1H40v3.2H24.3v-4.6c0-3.9 1.8-6.3 6.3-6.3", style: {
            fill: '#fff',
        } })));
export default SvgZdf;
